<template>
<!-- 整图样式 -->
  <div
    id="fullPic"
    class="fullPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ pic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
    <div @click="goLink" class="link" v-if="link"></div>
  </div>
</template>

<script>
export default {
  name: "fullPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["pic","link"],
  methods: {
    // 跳转链接
    goLink(){
       window.open(this.link)
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.fullPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
}
.link{
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/fullPic.vue